import type {ColumnDef} from '@tanstack/react-table';

import {Checkbox} from '@/components/ui/checkbox';

const tableSelectCol = <TData,>(): ColumnDef<TData> => ({
  id: 'select-col',
  enableHiding: false,
  meta: {className: 'w-12 min-w-12'},
  header: ({table}) => (
    <Checkbox
      className="align-middle"
      checked={
        table.getIsSomeRowsSelected()
          ? 'indeterminate'
          : table.getIsAllRowsSelected()
      }
      onCheckedChange={() => {
        table.toggleAllRowsSelected(!table.getIsAllRowsSelected());
      }}
    />
  ),
  cell: ({row}) => (
    <Checkbox
      className="align-middle"
      onClick={evt => {
        evt.stopPropagation();
      }}
      checked={row.getIsSelected()}
      disabled={!row.getCanSelect()}
      onCheckedChange={checked => {
        row.getToggleSelectedHandler()({target: {checked}});
      }}
    />
  ),
});

export default tableSelectCol;
